var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_682)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.24 8.4C16.6 8.4 17.6867 8.77333 18.5 9.52C19.3267 10.2667 19.74 11.2867 19.74 12.58C19.74 13.9267 19.3133 14.94 18.46 15.62C17.6067 16.3 16.4733 16.64 15.06 16.64L14.98 18.22H13L12.9 15.08H13.56C14.8533 15.08 15.84 14.9067 16.52 14.56C17.2133 14.2133 17.56 13.5533 17.56 12.58C17.56 11.8733 17.3533 11.32 16.94 10.92C16.54 10.52 15.98 10.32 15.26 10.32C14.54 10.32 13.9733 10.5133 13.56 10.9C13.1467 11.2867 12.94 11.8267 12.94 12.52H10.8C10.8 11.72 10.98 11.0067 11.34 10.38C11.7 9.75333 12.2133 9.26667 12.88 8.92C13.56 8.57333 14.3467 8.4 15.24 8.4ZM13.96 22.64C13.5467 22.64 13.2 22.5 12.92 22.22C12.64 21.94 12.5 21.5933 12.5 21.18C12.5 20.7667 12.64 20.42 12.92 20.14C13.2 19.86 13.5467 19.72 13.96 19.72C14.36 19.72 14.7 19.86 14.98 20.14C15.26 20.42 15.4 20.7667 15.4 21.18C15.4 21.5933 15.26 21.94 14.98 22.22C14.7 22.5 14.36 22.64 13.96 22.64Z",
    fill: "#10437B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d91df87385b65069c28a92a9de77042a.svg";
export { ForwardRef as ReactComponent };